<div class="addGateway" >
        <button *ngIf="authService.isSuperAdmin"
            mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('gateway')"
        >Add Gateway</button>
</div>
<div class="gateways-container">
        <mat-card class="gateway" *ngFor="let gateway of gateways">
                <mat-card-header>
                        <mat-card-title>
                                <div class="row">
                                        <div class="title">{{gateway.name | uppercase}}</div>
                                        <div class="title">
                                                <button *ngIf="authService.isSuperAdmin" mat-button mat-icon-button onclick="this.blur()" (click)="editGateway(gateway)">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                    <button *ngIf="authService.isSuperAdmin" mat-button mat-icon-button onclick="this.blur()" (click)="deleteGateway(gateway)">
                                                        <mat-icon>delete</mat-icon>
                                                </button>
                                        </div>   
                                </div>    
                        </mat-card-title>
                        <mat-card-subtitle>
                                <div class="gateway-status" *ngIf="gateway.online !== undefined; else notAvailable">
                                        <div class="flex items-center">
                                            <div class="indicator" [ngClass]="gateway.online ? 'online' : 'offline'"></div>
                                            Gateway status: {{gateway.online ? 'online' : 'offline'}}
                                        </div>
                                    </div>
                                    <ng-template #notAvailable>
                                        Gateway status: not available 
                                    </ng-template>
                                    <div class="gateway-id" *ngIf="gateway.hardwareId">
                                        Gateway id: {{gateway.id}}
                                    </div>
                                    <div class="gateway-id" *ngIf="gateway.hardwareId">
                                        Hardware id: {{gateway.hardwareId}}
                                    </div>
                                    <div class="gatewayStateNotificationn">
                                        <mat-slide-toggle [(ngModel)]="gateway.online" color="primary">Gateway State Notification</mat-slide-toggle>
                                    </div>
                        </mat-card-subtitle>
                </mat-card-header>
        </mat-card>
</div>



